import { render, staticRenderFns } from "./SalesByBrand.vue?vue&type=template&id=c9587db0&scoped=true"
import script from "./SalesByBrand.vue?vue&type=script&lang=js"
export * from "./SalesByBrand.vue?vue&type=script&lang=js"
import style0 from "./SalesByBrand.vue?vue&type=style&index=0&id=c9587db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9587db0",
  null
  
)

export default component.exports